import { getObserverFrame } from "../scene/observerFrame";
import type { SimulationSnapshot, Vector3 } from "../simulation/types";
import { dot, normalize } from "../simulation/vector";

const LUNAR_ALBEDO = [205, 202, 194] as const;

function sampleWithNormalizedLight(x: number, y: number, lightLocal: Vector3) {
  const radiusSquared = x * x + y * y;
  if (radiusSquared > 1) {
    return 0;
  }

  const z = Math.sqrt(Math.max(0, 1 - radiusSquared));
  return Math.max(0, dot([x, y, z], lightLocal));
}

export function samplePhaseBrightness(
  x: number,
  y: number,
  lightLocal: Vector3,
) {
  return sampleWithNormalizedLight(x, y, normalize(lightLocal));
}

export function drawPhaseDisk(
  canvas: HTMLCanvasElement,
  snapshot: SimulationSnapshot,
  size = 160,
) {
  const context = canvas.getContext("2d");
  if (context === null) {
    return;
  }

  canvas.width = size;
  canvas.height = size;
  const image = context.createImageData(size, size);
  const lightLocal = normalize(getObserverFrame(snapshot).lightLocal);

  for (let row = 0; row < size; row += 1) {
    const y = 1 - ((row + 0.5) / size) * 2;
    for (let column = 0; column < size; column += 1) {
      const x = ((column + 0.5) / size) * 2 - 1;
      const radiusSquared = x * x + y * y;
      const pixelOffset = (row * size + column) * 4;

      if (radiusSquared > 1) {
        image.data[pixelOffset + 3] = 0;
        continue;
      }

      const brightness = sampleWithNormalizedLight(x, y, lightLocal);
      image.data[pixelOffset] = Math.round(LUNAR_ALBEDO[0] * brightness);
      image.data[pixelOffset + 1] = Math.round(LUNAR_ALBEDO[1] * brightness);
      image.data[pixelOffset + 2] = Math.round(LUNAR_ALBEDO[2] * brightness);
      image.data[pixelOffset + 3] = 255;
    }
  }

  context.putImageData(image, 0, 0);
}
